import type { Message } from "@ag-ui/client";
import { hitlCallIds } from "./awaitingInput";

// The turn's new messages — the only ones the server needs on the wire. The
// database is the source of truth for history: the server rehydrates prior
// turns from it and appends what arrives here.
//
// A turn contributes exactly one of two shapes:
//   - a new user message (ordinary chat, including a follow-up typed under an
//     open card — the server closes that call from its own history), or
//   - the answers to the pause being answered now.
export function newOutboundMessages(messages: readonly Message[]): Message[] {
  const last = messages.at(-1);
  if (!last) return [];
  if (last.role !== "tool") return last.role === "user" ? [last] : [];
  // Two conditions, because each rules out a different wrong message. The
  // trailing run scopes the batch to this pause, so an earlier turn's answers
  // stay put and every sibling answered together still travels. Keeping only
  // HITL calls then drops an ordinary tool result the model asked for in the
  // same response: the server ran and persisted that one itself, so offering it
  // as an answer is a call it no longer shows pending, and it refuses the whole
  // resume — the one paused call included.
  const pauses = hitlCallIds(messages);
  let start = messages.length;
  while (start > 0 && messages[start - 1].role === "tool") start--;
  return messages.slice(start).filter((msg) => msg.role === "tool" && pauses.has(msg.toolCallId));
}
